import type { AdminNamespace } from '@cli-types/next-adapter/config.js'

export function replaceAdminPascalToken(value: string, namespace: AdminNamespace): string {
  return value.replaceAll('Admin', namespace.pascal)
}
